import { Email, Sms } from '@mui/icons-material'

import { preview } from '@/components/form/preview'
import { BackupEmailSubject } from '../../../../components/BackupEmailSubject'
import { NotificationPreview } from '../../../../components/NotificationPreview'
import { NotificationLimitations } from './components/NotificationLimitations'

import { useComputeSegmentsCount } from '@/hooks'
import type { EarlyNotificationValues } from '../../hooks/useEarlyNotificationValues'

import { useTexts } from './useTexts'

interface Props {
  values: EarlyNotificationValues
}

export function EarlyNotificationView(props: Props) {
  const { values } = props
  const texts = useTexts()

  const isEmailNotification = values.notificationWay === 'EMAIL'
  const isPhoneNotification = !isEmailNotification

  const tolerance =
    values.toleranceMins && values.toleranceMins !== '0'
      ? texts.notificationToleranceValue(values.toleranceMins)
      : texts.noTolerance

  const notificationWay = values.notificationWay === 'PHONE' ? 'SMS' : 'Email'

  const segmentsCount = useComputeSegmentsCount(
    { ...values.templateDefaultLimits, ...values.templateCustomLimits },
    values.templateCustom,
    values.includeMessageUnsubscriptionInstructions,
    values.includeMessageTrackingLink,
  )

  return (
    <>
      {/* Notification Limitations */}
      <NotificationLimitations />

      {/* Notification Tolerance */}
      <preview.Field testId="notification-tolerance" label={texts.notificationTolerance}>
        {tolerance}
      </preview.Field>

      {/* Notification Type */}
      {isEmailNotification && (
        <NotificationPreview
          icon={<Email color="action" />}
          notificationType={notificationWay}
          subject={values.subjectCustom}
          templatePreview={values.templatePreview}
        />
      )}

      {isPhoneNotification && (
        <>
          {/* SMS Body */}
          <NotificationPreview
            icon={<Sms color="action" />}
            notificationType={notificationWay}
            templatePreview={values.templatePreview}
            additionalTextDetails={texts.segmentsCount(segmentsCount)}
          />

          {/* E-mail backup subject */}
          {values.backupNotification && (
            <BackupEmailSubject
              icon={<Email color="action" />}
              subject={values.backupSubjectCustom}
            />
          )}
        </>
      )}
    </>
  )
}
